<div>
    <div class="loading-wrapper">
        <div *ngIf="isLoading" class="loading-container">
          <p>Loading...</p>
        </div>
      </div>
      
      
</div>